module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm7.44 13.266l-8.116 8.114a1.912 1.912 0 0 1-2.706 0L8.56 17.324c-.748-.746-.748-1.958 0-2.706s1.958-.748 2.706 0l2.706 2.706 6.764-6.764a1.912 1.912 0 1 1 2.704 2.706z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/checkmark-2.js
// module id = 1060
// module chunks = 14